function SportTabs({
    sports,
    activeSport,
    setActiveSport,
}) {

    return (
        <div style={styles.container}>
            {sports.map((sport) => (

                <button
                    key={sport.key}
                    onClick={() => setActiveSport(sport.key)}
                    style={{
                        ...styles.button,

                        ...(activeSport === sport.key
                            ? {
                                border: `2px solid ${sport.color}`,
                                color: sport.color,
                                background:
                                    "rgba(255,255,255,0.08)",
                            }
                            : {}),
                    }}
                >
                    {sport.label}
                </button>
            ))}
        </div>
    );
}

const styles = {

    container: {
        display: "flex",
        gap: "15px",
        marginBottom: "25px",
    },

    button: {
        padding: "12px 24px",
        borderRadius: "14px",
        border: "2px solid rgba(255,255,255,0.1)",
        background: "rgba(255,255,255,0.04)",
        color: "#aaa",
        cursor: "pointer",
        fontWeight: "bold",
    },
};

export default SportTabs;